import React from "react";

import { Box, TextField } from "@mui/material";

import { Source } from "Constant/source";

import FileUploadComponent from "components/FileUploadComponent";

const UploadSourceForm = ({
    language,
    upload,
    usage,
    setUsage,
    leadMappings,
    setLeadMappings,
    openMapping,
    hostActions,
}) => (
    <Box>
        <Box sx={{ mb: 3 }}>
            <TextField
                fullWidth
                type="text"
                label={language?.source_modal?.domain_name ?? "Domain / Name"}
                placeholder={
                    language?.source_modal?.please_do_not_leave_blank ??
                    "Please do not leave blank!"
                }
                autoFocus
                error={Boolean(upload.error)}
                helperText={upload.error || " "}
                onChange={upload.handleNameChange}
                value={upload.name}
                required
            />
        </Box>
        <FileUploadComponent
            file={upload.file}
            setFile={upload.setFile}
            source_type={Source.upload}
            buttonClicked={upload.isTriggered}
            setButtonClicked={upload.setIsTriggered}
            domain={upload.name}
            handleGetSources={hostActions.handleGetSources}
            tracker_id={hostActions.trackerId}
            addToTracker={hostActions.addToTracker}
            usage={usage}
            setUsage={setUsage}
            selectedLeadgenId={leadMappings}
            setSelectedLeadgenId={setLeadMappings}
            sourceMappingCheck={openMapping}
            isLoading={upload.isLoading}
            setIsLoading={upload.setIsLoading}
        />
    </Box>
);

export default UploadSourceForm;
